export default "__VITE_ASSET__DOmBVjM6__"